import React from 'react';

import {LOCAL_IMAGE_HOTLINKED_ATTR_NAME} from 'app/utils/constants';

import {UserContentImage} from './UserContentImage';

import {ProcessorType} from '../node-processors-types';
import {hasParentMatching} from '../node-processors-utils';

export const MakeImagesZoomableProcessor: ProcessorType = {
  tag: 'img',
  condition: () => true,
  processor: (node, index, transform, opts) => {
    const {mediaURL, mediaURLRead, imageSize} = opts;
    const insideLink = hasParentMatching(
      node,
      (parent) => parent.name === 'a' && parent.attribs.href != null
    );

    return [
      null,
      <UserContentImage
        key={index}
        src={node.attribs.src}
        style={node.attribs.style}
        localDownloadFailed={
          node.attribs[LOCAL_IMAGE_HOTLINKED_ATTR_NAME] != null
        }
        insideLink={insideLink}
        className={node.attribs.class}
        mediaURL={mediaURL}
        mediaURLRead={mediaURLRead}
        imageSize={imageSize}
      />,
    ];
  },
};
